(function(){
    'use strict';
    angular
    .module('app')
    .controller('DashboardController', DashboardController)
    DashboardController.$inject = ["DashboardService","FieldsService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
    function DashboardController(DashboardService,FieldsService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this; 

        vm.cuadros = [];
        //console.log("dash");

        vm.modalDash = "";

        

        vm.getDashboards = function(){
          DashboardService.getDashboards(function(data){
            vm.cuadros = data.dashboard;
          });
        }

        vm.config = function(cuadro){
          cuadro.configuracion = !cuadro.configuracion;
        }

        vm.guardarCuadro = function(cuadro){
        	DashboardService.saveDash(cuadro,function(data){
        		cuadro.configuracion = false;
        	});
        }

        vm.borrarCuadro = function(cuadro){
          var res = false;
          for(var cont=0;cont<vm.cuadros.length && !res;cont++){
            if(vm.cuadros[cont]==cuadro){
              vm.cuadros.splice(cont, 1);
              res = true;
            }
          }

        }

        vm.eliminarCuadro = function(cuadro){
          /*DashboardService.removeDash(cuadro,function(data){
            //BORRAMOS EL CUADRO
          });*/
          vm.modalDash = $uibModal.open({
              animation: true,
              windowClass : 'modal-danger',
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              templateUrl: 'borrarcuadro.html',
              size: 'lg',
              controller: function($scope) {
                $scope.okForm = function(){
                  DashboardService.removeDash(cuadro,function(data){
                      vm.borrarCuadro(cuadro);
                      vm.modalDash.close();
                  });
                }
                $scope.koForm = function(){
                    vm.modalDash.close();
                }
              }
            });
        }


        vm.loadCampo = function(cuadro,condicion){
      		condicion.valor="";
      		for(var cont=0;cont<cuadro.config.fields.length;cont++){
      			if(cuadro.config.fields[cont].name==condicion.campo){
      				condicion.field = cuadro.config.fields[cont];
      				if(condicion.field.value != '')
          				condicion.field.value = JSON.parse(condicion.field.value);
      			}
      		}
      		$timeout(function(){
      			$('.datepicker').datepicker({ format: 'yyyy-mm-dd'});
      		})
      	}


        vm.addCuadro = function(){
    				vm.modalDash = $uibModal.open({
    		              animation: true,
    		              //windowClass : 'modal-success',
    		              ariaLabelledBy: 'modal-title-top',
    		              ariaDescribedBy: 'modal-body-top',
    		              templateUrl: 'addcuadro.html',
    		              size: 'lg',
    		              controller: function($scope) {
                        $scope.nodetype = "";
    		              	$scope.addCuadro = function(tipo_cuadro){
                          FieldsService.getFieldsByNode($scope.nodetype,false,function(data){
      		              		var varCuadro = {"tipo_cuadro":tipo_cuadro, config:{ condiciones : [], fields : data.fields, fieldsSelected : data.selecteds }, configuracion:true};
      		              		if(tipo_cuadro=="listactividad"){
                              varCuadro.type = $scope.nodetype;
      		              			varCuadro.config.dias = 7;
      		              		}
      		              		vm.cuadros.push(varCuadro);
      		              		vm.modalDash.close();
                          });
    		              	}
    		              	$scope.okForm = function(){
    		              		vm.modalDash.close();
    		                }
    		                $scope.koForm = function(){
    		                    vm.modalDash.close();
    		                }
    		              }
    		        });
        }
    } 
  
})();